export interface PageProgressProps {
  active: boolean;
}

export function PageProgress({ active }: PageProgressProps) {
  return (
    <div
      className={`vania-page-progress${active ? ' is-active' : ''}`}
      role="progressbar"
      aria-label="در حال بارگذاری"
      aria-hidden={!active}
    />
  );
}
